import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import "./styles-drawer.css";
import { useDrawerLayer } from './drawerLayerStack';

export const DrawerCustomClean = ({
    isOpen,
    toggleDrawer,
    children,
    direction = 'right',
    sizeSM = '100%',
    sizeMD = '65%',
    sizeLG = '35%',
}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { zIndex } = useDrawerLayer({
        isOpen,
        onRequestClose: toggleDrawer,
    });

    return createPortal(
        <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction={direction}
            size={windowWidth < 868 ? sizeSM : windowWidth <= 1024 ? sizeMD : sizeLG}
            overlayOpacity={0.4}
            zIndex={zIndex}
            style={{
                backgroundColor: 'transparent',
                height: '100dvh',
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: `${direction === 'left' & windowWidth > 868 ? '15px' : '0px'}`,
                marginRight: `${direction === 'right' & windowWidth > 868 ? '15px' : '0px'}`,
            }}
        >
            <div
                className={`${windowWidth > 868 ? "w-[100%]" : "w-[96%]"} flex flex-col rounded-lg bg-white shadow-md`}
                style={{ height: "96vh", height: "96dvh" }}
            >
                <section className="flex flex-col h-full">

                    {/* Contenido que ocupa el espacio restante */}
                    <main className="flex-1 overflow-auto overscroll-contain">
                        {children}
                    </main>

                </section>
                {/* {children} */}
            </div>
        </Drawer>,
        document.body,
    )
}
